module.exports = __webpack_public_path__ + "19a4c1e1857e409a17353cb576128578.fbx";